<template>
  <v-app id="inspire">
    <v-navigation-drawer
      v-model="drawer"
      app
      class=""
      width="100"
      v-if="user.email"
    >
    <!-- header -->
    <v-col class="pa-0 ma-0 black--text white text-center py-6 mb-6">
      <img src="/img/favicon.png" height="50" contain />
    </v-col>

    <v-btn @click="toggleTabBar" elevation="0" large class="mx-2 mb-3">
      <v-icon :color="tabBarActive ? 'primary' : ''">mdi-calendar</v-icon>
    </v-btn>
    <v-btn @click="listWarnings()" elevation="0" large class="mx-2 mb-3">
      <v-icon> mdi-alert</v-icon>
    </v-btn>
    <!--<v-btn to="/members" elevation="0" large class="mx-2 mb-3">
      <v-icon> mdi-account</v-icon>
    </v-btn>-->
    <v-btn elevation="0" large class="mx-2 mb-3" v-if="false">
      <!-- checklist -->
      <v-icon> mdi-stop</v-icon>
    </v-btn>
    <!-- cog -->
    <v-btn elevation="0" large class="mx-2 mb-3" v-if="false">
      <v-icon> mdi-cog</v-icon>
    </v-btn>
    <!-- logout -->
    <v-btn elevation="0" @click="logout()" large class="mx-2 mb-3" >
      <v-icon> mdi-logout</v-icon>
    </v-btn>
    
    
    </v-navigation-drawer>
    <v-main>
      <v-dialog v-model="confirmDialog" max-width="400">
           <v-card>
               <v-card-title class="text-h5">Confirmer la suppression</v-card-title>
               <v-card-text>
                   Êtes-vous sûr de vouloir supprimer ce signalement ?
               </v-card-text>
               <v-card-actions>
                   <v-spacer></v-spacer>
                   <v-btn color="gray" @click="confirmDialog = false ; showList = true">Annuler</v-btn>
                   <v-btn color="red" @click="deleteSignalement">Supprimer</v-btn>
               </v-card-actions>
           </v-card>
       </v-dialog>
       <v-dialog v-model="imageDialog" max-width="600" content-class="custom-dialog">
            <v-card>
                <v-card-actions>
                    <v-card-title>Photo du signalement</v-card-title>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="imageDialog = false">Fermer</v-btn>
                </v-card-actions>
                
                <v-card-text class="text-center">
                    <v-img :src="selectedImage" contain max-height="400"></v-img>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!-- Liste des signalements -->
         <v-dialog v-model="showList" max-width="600">
             <v-toolbar dark color="primary">
                 <v-btn icon dark @click="showList = false">
                     <v-icon>mdi-close</v-icon>
                 </v-btn>
                 <v-toolbar-title>Signalements</v-toolbar-title>
                 <v-spacer></v-spacer>
             </v-toolbar>
             <v-list>
                 <v-list-item v-for="signalement in MySignalements" :key="signalement.id">
                     
                     <!-- Avatar avec l'image -->
                     <v-list-item-avatar>
                         <v-img v-if="signalement.photo" :src="getImageUrl(signalement.photo)" alt="Photo signalement" @click="openImage(signalement.photo)"></v-img>
                     </v-list-item-avatar>
             
                     <!-- Contenu du signalement -->
                     <v-list-item-content>
                         <v-list-item-title>{{ signalement.type_text }} ({{ signalement.state }})</v-list-item-title>
                         <v-list-item-subtitle>{{ signalement.comment }}</v-list-item-subtitle>
                         <v-list-item-subtitle>
                             Pos. : {{ signalement.position.coordinates[0].toFixed(3) }}, {{ signalement.position.coordinates[1].toFixed(3) }} - Créé le : {{ signalement.created_at_formatted }}
                         </v-list-item-subtitle>
                     </v-list-item-content>
         
                     <!-- Bouton de suppression -->
                     <v-list-item-action>
                         <v-btn icon color="red" @click="showList = false ; confirmDelete(signalement.id)">
                             <v-icon>mdi-delete</v-icon>
                         </v-btn>
                     </v-list-item-action>
         
                 </v-list-item>
             </v-list>
         </v-dialog>
      <router-view />
    </v-main>
    <span v-if="timeNDVI" class="ndvi-update">&nbsp;NDVI update:<br />&nbsp;{{timeNDVI}}<br />Version: {{version}}</span>
    <span v-else class="ndvi-update">&nbsp;NDVI update:<BR/>&nbsp;none<br />Version: {{version}}</span>
  </v-app>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import axios from 'axios';
import pkg from '../package.json'; // ajuster le chemin si besoin

export default {
  name: 'App',
  computed:{
    ...mapState(['user','tabBarActive']),
    ...mapGetters(['getTabBarActive']), // Récupérer via le getter
    tabBarActive() {
      return this.getTabBarActive; // Renommer pour être plus lisible
    },
  },
  data: () => ({
    drawer: true,    
    timeNDVI: null,
    showList: false,
    confirmDialog: false,
    imageDialog: false,
    MySignalements: [],
    selectedImage: null,
    version: pkg.version,
    signtype: [
        { text: 'Inondation', value: 'flood' },
        {
            text: 'Déchets',
            value: 'waste'
        },
        {
            text: 'Plantes invasives',
            value: 'invasible plant'
        },
        {
            text: 'Obstacle',
            value: 'obstacle'
        },
        {
            text: 'Zone inaccessible',
            value: 'accessibility'
        },
        {
            text: 'Animaux',
            value: 'animals'
        },
        
        {
            text: 'Autre',
            value: 'other'
        }
    ],
  }),
  methods:{
    ...mapActions(['toggleTabBar']), // Utilise l'action du store
    getImageUrl(photo) {
        return `${process.env.VUE_APP_DIRECTUS_URI}/assets/${photo}`;
    },
    openImage(photo) {
        this.selectedImage = this.getImageUrl(photo);
        this.imageDialog = true;
    },
    confirmDelete(id) {
        this.selectedSignalementId = id;
        this.confirmDialog = true;
    },
    
    async deleteSignalement() {
        if (!this.selectedSignalementId) return;        
        try {
            await this.$directus.items("Signalements").deleteOne(this.selectedSignalementId);
            this.MySignalements = this.MySignalements.filter(signalement => signalement.id !== this.selectedSignalementId);
            this.confirmDialog = false;
            console.log("Signalement supprimé avec succès");
        } catch (error) {
            console.error("Erreur lors de la suppression :", error);
        }
        this.showList = true;
    },
    async getUserSignalements() {
        try {
            this.showList = true;
            const signalements = await this.$directus.items('Signalements').readByQuery({
                sort: '-id', // Trie par ordre décroissant pour avoir les plus récents en premier                
            });
    
            //console.log("MySignalements:", signalements.data);
            this.MySignalements = signalements.data;
            this.MySignalements = this.MySignalements.map(signalement => {
                // Trouver le texte correspondant au type
                const matchedType = this.signtype.find(item => item.value === signalement.type);
            
                // Formatter la date
                const date = new Date(signalement.created_at);
                const day = date.getDate().toString().padStart(2, '0');
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const year = date.getFullYear();
                const hours = date.getHours().toString().padStart(2, '0');
                const minutes = date.getMinutes().toString().padStart(2, '0');
                const created_at_formatted = `${day}/${month}/${year} à ${hours}:${minutes}`;
            
                // Retourner l'objet enrichi
                return {
                    ...signalement,
                    type_text: matchedType ? matchedType.text : 'Type inconnu',
                    created_at_formatted
                };
            });
            console.log("this.MySignalements",this.MySignalements);
        } catch (error) {
            console.error("Erreur lors de la récupération des signalements:", error);
        }
    },
    listWarnings() {
      this.getUserSignalements();
      this.showList=true;
      //alert('warnings')
    },
    logout(){
      localStorage.clear()
      this.$store.dispatch('setToken', null)
      this.$store.dispatch('setUser', {})
      this.$router.push('/login')
    },
    async initNDVI() {
      let start = this.$moment().subtract(3, 'month').unix();
      let end = this.$moment().subtract(0, 'week').unix();
      let url = `https://api.agromonitoring.com/agro/1.0/image/search?end=${end}&start=${start}&polyid=674dc3d4d444b63e981ab479&appid=28c103f6b7a9e33d8f9305ef901d3939&clouds_max=70`;
      //console.log('url agro', url);
      let data = await axios.get(url);
       //console.log(data);
      data.data.reverse();
      this.tileNDVI = data.data.find(map => map.cl < 80).tile.ndvi.replace('http', 'https');
      let timestampNDVI = data.data.find(map => map.cl < 80).dt;
      const date = new Date(timestampNDVI*1000);
      console.log(this.tileNDVI,timestampNDVI)
      // Formater en chaîne lisible
      this.timeNDVI = date.toLocaleDateString('fr-FR');
      console.log('timeNDVI', this.timeNDVI)
      
    
    },
    async getZones(){
      let zones = await this.$directus.items('Parcours').readByQuery({
        limit:-1
      })
      this.$store.dispatch('setZones', zones.data)
    }
  },
  mounted(){
    this.getZones();
    this.initNDVI();
  }
};
</script>

<style>
/* exlude icon */

.v-tab {
    text-align: left!important;
}

.theme--dark .v-navigation-drawer, .theme--dark.v-tabs > .v-tabs-bar, .theme--dark.v-tabs-items {
  background-color: #2E3344!important;
}

.vis-item{
  background-color: #F4A900!important;
  color:white!important;
  font-weight:bold!important;
}
.ndvi-update {
    position: relative;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    color: white;
    padding: 0px;
    font-size: 10px;
    z-index: 1000;
    margin-top:-60px;
}

.custom-dialog {
  position: fixed !important;
  top: 5vh !important; /* Ajuste la position verticale */
  transform: none !important; /* Supprime l'effet par défaut de Vuetify */
}
</style>